module.exports = __webpack_public_path__ + "assets/img/Pioneer_Chassard_Chapellier.051191d8-ps.jpg";